'use client';

import React from 'react';
import { CameraOutlined, EditOutlined } from '@ant-design/icons';

interface SidebarReviewCTAsProps {
  entityName: string;
}

/**
 * Compact sidebar cards that prompt users to upload photos or write
 * a review. Communicates with EntityReviews via custom DOM events.
 */
const SidebarReviewCTAs: React.FC<SidebarReviewCTAsProps> = ({ entityName }) => {
  const handleUploadPhoto = () => {
    window.dispatchEvent(new CustomEvent('open-photo-upload'));
  };

  const handleWriteReview = () => {
    window.dispatchEvent(new CustomEvent('open-review-form'));
  };

  return (
    <div className="ca-side-review bg-white rounded-lg shadow-sm border p-6">
      <h3 className="text-base font-semibold text-gray-900 mb-2">
        Share Your Experience
      </h3>
      <p className="text-sm text-gray-500 mb-4">
        Help fellow campers by sharing your photos and reviews.
      </p>
      <div className="flex flex-col gap-2">
        <button
          onClick={handleUploadPhoto}
          className="flex items-center justify-center gap-2 w-full px-4 py-2.5 rounded-lg border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100 transition-colors"
        >
          <CameraOutlined />
          Upload a Photo
        </button>
        <button
          onClick={handleWriteReview}
          className="flex items-center justify-center gap-2 w-full px-4 py-2.5 rounded-lg bg-amber-500 text-sm font-medium text-white hover:bg-amber-600 active:bg-amber-700 transition-colors"
        >
          <EditOutlined />
          Write a Review
        </button>
      </div>
    </div>
  );
};

export default SidebarReviewCTAs;
